import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isLength from 'validator/lib/isLength';

// Global parameters
export const MIN_LENGTH_MESSAGE_CONTACT_US = 50;

export type TContactUsValues = {
  name: string;
  email: string;
  message: string;
};

type ContactUsValues = Partial<TContactUsValues>;

export const contactUsValidation = ({ email = '', name = '', message = '' }: ContactUsValues): ContactUsValues => {
  const errors: ContactUsValues = {};

  // Email
  if (!isEmail(email)) errors.email = 'Invalid Email address';
  if (isEmpty(email)) errors.email = 'Required field';

  // Name
  if (isEmpty(name)) errors.name = 'Required field';

  // Message
  if (!isLength(message.trim(), { min: MIN_LENGTH_MESSAGE_CONTACT_US }))
    errors.message = `Minimum ${MIN_LENGTH_MESSAGE_CONTACT_US} characters`;
  if (isEmpty(message)) errors.message = 'Required field';

  return errors;
};
